<mat-form-field appearance="outline" class="time-input__field">
  @if (label()) {
    <mat-label>{{ label() }}</mat-label>
  } @else {
    <mat-label>
      <ng-content select=".label" />
    </mat-label>
  }

  <input
    matInput
    type="text"
    [placeholder]="placeholder()"
    [matAutocomplete]="auto"
    [formControl]="control()"
    maxlength="5"
    inputmode="tel"
    pattern="(?:[01]\d|2[0-3]):[0-5]\d"
    (blur)="onBlur()"
    (focus)="onFocus($event)"
    (input)="onInput($event)"
    (keydown)="onKey($event)"
  />

  <mat-autocomplete #auto="matAutocomplete">
    @for (opt of filteredOptions$ | async; let idx = $index; track idx) {
      <span
        [matTooltip]="getTooltip(opt)"
        [matTooltipDisabled]="!getTooltip(opt)"
        matTooltipPosition="right"
      >
        <mat-option
          [value]="opt"
          [disabled]="isOptionDisabled()?.(opt) ?? false"
          class="without-checkbox"
        >
            {{ opt }}
        </mat-option>
       </span>
    }
  </mat-autocomplete>
</mat-form-field>
